import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';

import PageTitle from 'components/common/PageTitle';

const styles = () => ({
  root: {
    marginBottom: 16,
  },
});

const PatientCreateToolbar = ({ title, href, classes }) => (
  <Toolbar
    className={classes.root}
    disableGutters
  >
    <Grid
      container
      justify="space-between"
      alignItems="center"
      spacing={24}
    >
      <Grid item>
        <PageTitle
          text={title}
          href={href}
          variant="button"
        />
      </Grid>
    </Grid>
  </Toolbar>
);

PatientCreateToolbar.propTypes = {
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PatientCreateToolbar);



// WEBPACK FOOTER //
// ./src/components/patient/PatientCreateToolbar/PatientCreateToolbar.js